import { TableFilterState } from '@ibsys/kit';
import type { SearchKnowledgeSetFilters } from '@/entities/search';
import { tableFilters2Query } from '@/shared/lib';

/** Builds filters for knowledge_set entity (isDeleted, spec: filters by entityType) */
export const buildKnowledgeSetFilters = (filters: TableFilterState): SearchKnowledgeSetFilters | undefined => {
  const searchFilters = tableFilters2Query(filters);
  return Object.keys(searchFilters).length > 0 ? (searchFilters as SearchKnowledgeSetFilters) : undefined;
};
